import {Action, ThunkAction, configureStore} from '@reduxjs/toolkit';
import {authWithEmailSlice} from './slices/auth_with_email_slice';
import {exchangeTokenSlice} from './slices/exchange_token_slice';
import {useDispatch, useSelector} from 'react-redux';
import {customerInfoSlice} from './slices/me_slice';
import {chatSlice} from './slices/chat_slice';
import {notificationsSlice} from './slices/notifications_slice';
import {appConfigSlice} from './slices/app_config_slice';
import {occasionsSlice} from './slices/occasions_slice';
import {occasionBrandsSlice} from './slices/occasion_brands_slice';
import {toastErrorMiddleware} from './toast_error_middleware';
import {failureIndicatorSlice} from './slices/failure_indicators_slice.ts';
import {leadProvidersSlice} from './slices/lead_providers_slice.ts';
import {leadsSlice} from './slices/leads_slice.ts';
import {newsSlice} from './slices/news_slice.ts';
import {reviewSlice} from './slices/review_slice.ts';

export const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(toastErrorMiddleware),
    reducer: {
        authWithEmail: authWithEmailSlice.reducer,
        exchangeToken: exchangeTokenSlice.reducer,
        customerInfo: customerInfoSlice.reducer,
        chat: chatSlice.reducer,
        notifications: notificationsSlice.reducer,
        appConfig: appConfigSlice.reducer,
        occasions: occasionsSlice.reducer,
        occasionBrands: occasionBrandsSlice.reducer,
        failureIndicators: failureIndicatorSlice.reducer,
        leadProviders: leadProvidersSlice.reducer,
        leads: leadsSlice.reducer,
        news: newsSlice.reducer,
        reviews: reviewSlice.reducer,
    },
});

type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector = useSelector.withTypes<RootState>();
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
